import {safeSessionStorage} from "@/lib/utils/storage";
import {generateUuid} from "@/lib/utils";

/**
 * Per-session id, attached to every event as a super-property so a visit can be
 * reconstructed as a sequence. Scoped to `sessionStorage`, so it survives
 * in-session navigation and reloads but resets on a new tab/visit — which is
 * the definition of "session" the tracking plan assumes.
 *
 * Distinct from `anonymous_id` (visitor-scoped, ~1 year) — do not conflate them.
 */

const SESSION_ID_KEY = "mp_session_id";

export const getSessionId = (): string => {
    if (typeof window === "undefined") return "";

    let id = safeSessionStorage.getItem(SESSION_ID_KEY);
    if (!id) {
        id = generateUuid();
        safeSessionStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
};
